import type { OrganizationContact } from '@engagement-web-app/common';
import { FileText, Mail } from 'lucide-react';
import { Avatar } from '@/components/Avatar';
import { Flex } from '@/components/Flex';
import { Icon } from '@/components/Icon';
import { Skeleton } from '@/components/Skeleton';
import { formatPhoneNumber } from '@/utils';
import * as styles from './PrimaryContactSection.css';

type PrimaryContactSectionProps = {
    contact: OrganizationContact | null;
};

export function PrimaryContactSection({ contact }: PrimaryContactSectionProps) {
    if (!contact) {
        return (
            <div className={styles.container}>
                連絡先は​まだ​登録されていません。​右上の​「連絡先を​登録する」​ボタンから、​連絡先を​登録してください。​
            </div>
        );
    }

    const { lastName, firstName, email, phone } = contact;

    return (
        <Flex className={styles.container} gap="4">
            <Avatar size="l" mode="client" />
            <Flex direction="column" gap="2">
                <p className={styles.primaryContactName}>
                    {lastName} {firstName}
                </p>
                {email && (
                    <Flex gap="2" align="center" className={styles.detailRow}>
                        <Icon icon={Mail} size="sm" className={styles.detailIcon} />
                        <a href={`mailto:${email}`} className={styles.detailText}>
                            {email}
                        </a>
                    </Flex>
                )}
                {phone && (
                    <Flex gap="2" align="center" className={styles.detailRow}>
                        <Icon icon={FileText} size="sm" className={styles.detailIcon} />
                        <a href={`tel:${phone}`} className={styles.detailText}>
                            {formatPhoneNumber(phone)}
                        </a>
                    </Flex>
                )}
            </Flex>
        </Flex>
    );
}

export function PrimaryContactSectionSkeleton() {
    return (
        <Flex className={styles.container} gap="4">
            <Avatar size="l" mode="client" />
            <Flex direction="column" gap="2">
                <Skeleton.Line width={120} height="base" />
                <Skeleton.Line width={160} height="sm" />
                <Skeleton.Line width={120} height="sm" />
            </Flex>
        </Flex>
    );
}
